import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Tooltip} from 'antd';

const FormError = ({errors, fieldName}) => _.get(errors, fieldName, []).map(
    (error, index) => <p className="error-msg" key={index}>{error}</p>
);

FormError.propTypes = {
    errors: PropTypes.object.isRequired,
    fieldName: PropTypes.string.isRequired,
};


const FormErrorTooltip = ({errors, fieldName, children}) => {
    const currentErrors = _.get(errors, fieldName, []);
    const errorMsg = currentErrors.join('\n');
    return (<Tooltip placement="bottomLeft" overlayClassName="error-msg-tooltip" title={errorMsg}>
        {React.Children.map(children, (child => React.cloneElement(child, { className: currentErrors.length > 0 ? 'has-error' : '' })))}
    </Tooltip>);
};

FormErrorTooltip.propTypes = {
    errors: PropTypes.object.isRequired,
    fieldName: PropTypes.string.isRequired,
    children: PropTypes.any,
};

FormError.Tooltip = FormErrorTooltip;

export default FormError;



// WEBPACK FOOTER //
// /src/components/FormError.jsx